
import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'


const VideoTop = styled.div`
  margin: 0 auto;
  position: relative;
  z-index: 2;
  max-width: 1100px;
  padding: 0 0;
  margin-bottom: ${LAYOUT.VERTICALSPACEMOBILE};
  ${MEDIA.medium`
    padding: 0 60px;
    margin-bottom: ${LAYOUT.VERTICALSPACE};
  `}
`

export default VideoTop
